var map = {
	"./commander.png": 1835,
	"./forme.png": 275,
	"./imprimante.png": 1836,
	"./menu.png": 1837,
	"./multipad.png": 1838,
	"./pause.png": 276,
	"./play.png": 522,
	"./power.png": 1839,
	"./service.png": 1840,
	"./table.png": 1841,
	"./timer.png": 1842,
	"./toque.png": 1843,
	"./valide.png": 274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1834;